import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const AddItemToDemarqueForm = ({ refDemarque, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_DEM"
      refValue={refDemarque}
      onSuccess={onSuccess}
      priceType="none"
      enableBatch={true}
      useArticleList={false}
      extraFields={{ REMARQUE: '' }}
      submitButtonText="Add all to Demarque"
    />
  );
};

export default AddItemToDemarqueForm;

